import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 02 — Quick Quiz · stage-prop driven.
 *
 *   stage = 0  →  "Quick Quiz." headline (calm hero)
 *   stage = 1  →  the question replaces the headline
 *
 * No internal state any more — each stage is its own registered slide so
 * arrow navigation works reliably across all environments. The cinematic
 * cross-fade now lives in SceneStage's slide-to-slide transition.
 */
export default function Scene02_QuizQuestion({ stage = 0 }) {
  return (
    <SceneShell variant="forest" align="center" data-testid="scene-quiz-question">
      <motion.div
        className="absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(150,193,31,0.22) 0%, transparent 60%)",
          filter: "blur(40px)",
        }}
        animate={{ x: [0, 30, 0], y: [0, -20, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1600px] mx-auto w-full text-center flex items-center justify-center">
        {stage === 0 ? (
          <motion.h1
            initial={{ opacity: 0, scale: 0.94, filter: "blur(14px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
            className="kn-display leading-[0.92] text-center pb-2"
            style={{
              fontSize: "clamp(96px, 14vw, 220px)",
              color: "#ffffff",
              fontWeight: 900,
              letterSpacing: "-0.04em",
            }}
            data-testid="quiz-hero"
          >
            Quick{" "}
            <span
              style={{
                background: "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
                textShadow: "0 0 100px rgba(150,193,31,0.45)",
              }}
            >
              Quiz.
            </span>
          </motion.h1>
        ) : (
          <motion.div
            initial={{ opacity: 0, scale: 0.96, filter: "blur(14px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="text-center"
            data-testid="quiz-question-text"
          >
            <div
              className="kn-display leading-[1.05]"
              style={{
                fontSize: "clamp(56px, 8vw, 132px)",
                color: "#ffffff",
                fontWeight: 900,
                letterSpacing: "-0.03em",
                textShadow: "0 0 80px rgba(150,193,31,0.30)",
              }}
            >
              How many videos are watched online{" "}
              <span
                style={{
                  background:
                    "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                every day?
              </span>
            </div>
          </motion.div>
        )}
      </div>
    </SceneShell>
  );
}
